var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "create-btn" },
        [
          _c(
            "v-btn",
            {
              staticClass: "ml-3",
              attrs: {
                small: "",
                outlined: "",
                rounded: "",
                color: "secondary"
              },
              on: {
                click: function($event) {
                  _vm.newDocumentVisible = true
                }
              }
            },
            [_vm._v("Criar documento")]
          ),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(Object.keys(_vm.documents), function(document_type) {
        return [
          _vm.isOcrDocument(_vm.documents[document_type]["document_type"])
            ? _c(
                "div",
                {
                  key: _vm.documents[document_type]["id"],
                  staticClass: "style"
                },
                [
                  _c("div", { staticClass: "title_header" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("getDocumentTypeStatuses")(
                            _vm.documents[document_type]["document_type"]
                          )
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "property" }, [
                      _vm._v("\n          STATUS:\n          "),
                      _c(
                        "span",
                        {
                          style: _vm.getStatus(
                            _vm.documents[document_type]["status"],
                            "color"
                          )
                        },
                        [
                          _c("icon-tooltip", {
                            attrs: {
                              options: _vm.getStatus(
                                _vm.documents[document_type]["status"]
                              )
                            }
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("getStatuses")(
                                  _vm.documents[document_type]["status"],
                                  "name"
                                )
                              )
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.documents[document_type]["status"] === "approved" ||
                    _vm.documents[document_type]["status"] === "reproved"
                      ? _c(
                          "div",
                          { staticClass: "property" },
                          [
                            _vm._v("\n          SITUAÇÃO:\n          "),
                            _c(
                              "v-chip",
                              {
                                style: _vm.isApproved(
                                  _vm.documents[document_type]["approved"]
                                ),
                                attrs: { small: "", outlined: "" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isApproved(
                                      _vm.documents[document_type]["approved"]
                                    ).name
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _vm._v("\n          COMBATE A FRAUDE ID:\n          "),
                        _c("v-chip", { attrs: { small: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatExternalId(
                                _vm.documents[document_type]["external_id"]
                              )
                            )
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isOcrDocument(
                    _vm.documents[document_type]["document_type"]
                  )
                    ? _c("document-path", {
                        staticClass: "paths",
                        attrs: {
                          paths: _vm.documents[document_type]["paths"],
                          documentType: document_type
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOcrDocumentContent(
                    _vm.documents[document_type]["document_type"]
                  )
                    ? _c("document-content", {
                        attrs: { document: _vm.documents[document_type] }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "management-btn" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          attrs: {
                            color: "primary",
                            small: "",
                            loading:
                              _vm.documents[document_type][
                                "documentSavingLoader"
                              ],
                            disabled:
                              _vm.documents[document_type][
                                "documentApprovingLoader"
                              ]
                          },
                          on: {
                            click: function($event) {
                              _vm.updateByDocumentType(document_type),
                                _vm.refreshCurrentContext()
                            }
                          }
                        },
                        [_c("span", [_vm._v("salvar")])]
                      ),
                      _vm._v(" "),
                      _vm.isDocumentHandled(
                        _vm.documents[document_type]["status"]
                      )
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: {
                                color: "yellow",
                                loading:
                                  _vm.documents[document_type][
                                    "documentApprovingLoader"
                                  ],
                                disabled:
                                  _vm.documents[document_type][
                                    "documentSavingLoader"
                                  ],
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  _vm.approveDocument(document_type),
                                    _vm.refreshCurrentCotext()
                                }
                              }
                            },
                            [_c("span", [_vm._v("Aprovar Documento")])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDocumentProcessing(
                        _vm.documents[document_type]["status"]
                      )
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: {
                                color: "accent",
                                loading:
                                  _vm.documents[document_type][
                                    "documentApprovingLoader"
                                  ],
                                disabled:
                                  _vm.documents[document_type][
                                    "documentSavingLoader"
                                  ],
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setDocumentPendingApprovalDocumentType(
                                    document_type
                                  )
                                }
                              }
                            },
                            [_c("span", [_vm._v("Solicitar aprovação manual")])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDocumentReadyToProcess(
                        _vm.documents[document_type]["status"]
                      )
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                loading:
                                  _vm.documents[document_type][
                                    "documentApprovingLoader"
                                  ],
                                disabled:
                                  _vm.documents[document_type][
                                    "documentSavingLoader"
                                  ],
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  _vm.setDocumentReadyToProcessByDocumentType(
                                    document_type
                                  ),
                                    _vm.refreshCurrentContext()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v("Documento pronto para analise")
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _c("create", {
        attrs: {
          visible: _vm.newDocumentVisible,
          professional: _vm.professional
        },
        on: {
          close: function($event) {
            _vm.newDocumentVisible = false
          },
          refresh: function($event) {
            return _vm.listAllProfessionalDocuments()
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05577fee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05577fee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Documents.vue
// module id = null
// module chunks = 